import { QUERY_PARAM_PIEFIX_KEY } from "../../const";

export const getQueryParamKey = (shopId) => {
  if (!shopId) return QUERY_PARAM_PIEFIX_KEY;
  return `${QUERY_PARAM_PIEFIX_KEY}_${shopId}`;
};
